import React, { ChangeEvent, CSSProperties, FC } from 'react';
import './style.scss';

interface InputProps {
    placeholder: string;
    value?: string;
    name?: string;
    onChange?: (e: ChangeEvent) => void;
    style?: CSSProperties;
}

const Input: FC<InputProps> = (attributes) => {
    return <input type='text' {...attributes} autoComplete='off' className='sobrusPost__control' />;
};

export { Input };
